import React from "react";
import styles from "./Hamburger.module.scss";
import { useAppContext } from "../../../context/AppContext";
import { useGlobalContext } from "@aleksundshantu/aunds-utils-react/contexts";
import { CustomSVG } from "@/components/_primitives/CustomSVG/CustomSVG.client";

export const Hamburger = ({}) => {
  const { openMenu, setOpenMenu } = useAppContext();
  const { getIcon, label } = useGlobalContext();
  /// Label is only for AAA compliance, not AA
  // const label = openMenu
  //   ? getLabel("main_menu_close_label")
  //   : getLabel("main_menu_label");
  return (
    <button
      onClick={() => setOpenMenu((last) => !last)}
      className={`${styles["hamburger"]} is-hidden-after-navbar-breakpoint
      ${openMenu ? `navbar-menu-burger-close ${styles["navbar-menu-burger-close"]}` : `navbar-menu-burger ${styles["navbar-menu-burger"]}`}`}
      aria-label={label("global", "aria_label", "hamburger", {
        de: "Öffnet und schließt das Menü",
        en: "open and close the main menu",
      })}
      aria-controls="navbar-main"
      aria-expanded={openMenu}
    >
      {/* {label && <span className={styles["menu-label"]}>{label}</span>} */}
      {openMenu ? (
        <CustomSVG
          src={getIcon("close")}
          wrapper={"span"}
          key={"close"}
          width={"100%"}
          height={"100%"}
          aria-hidden="true"
          className="is-flex"
        />
      ) : (
        <CustomSVG
          src={getIcon("menu")}
          wrapper={"span"}
          key={"open"}
          width={"100%"}
          height={"100%"}
          aria-hidden="true"
          className="is-flex"
        />
      )}
    </button>
  );
};
